module.exports = __webpack_public_path__ + "static/media/Cacturne_gaussian2.6ee41329.png";